import { render, staticRenderFns } from "./Collect9.vue?vue&type=template&id=8be4f4a6&scoped=true&lang=pug&"
import script from "./Collect9.vue?vue&type=script&lang=ts&"
export * from "./Collect9.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be4f4a6",
  null
  
)

export default component.exports